import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { Notification } from "../models/x-app";

export function useNotify() {
  const app = useContext(AppContext)!;
  return (notification: Notification) => app.next(notification);
}
